<div class="items">
  <h4 class="text">У вас нет сохраненных карт</h4>
  <button sdButton class="button button-add-payment" type="primary" size="l" (click)="addPayment.emit()">
    Добавить карту
  </button>
</div>
